<template>
  <div id="app">
    <wall/>
  </div>
</template>

<script>
import Wall from '@/views/Wall';

export default {
  name: 'app',
  components: {
    Wall
  }
};
</script>
